import { LabelHTMLAttributes } from 'react';

export default function InputLabel({ value, className = '', children, ...props }: LabelHTMLAttributes<HTMLLabelElement> & { value?: string }) {
    return (
        <label {...props} className={`label-text block text-sm font-semibold text-base-content ${className}`}>
            {value ? value : children}
        </label>
    );
}
